<template>
 <main>
  <p>I finally started, July 2019, using my site as a blog for the tools and projects I create or am involved in. I had this site up before, but the code was antiquated and out of date. The old site ran on a LAMP stack and I have since upgraded my server clusters to MEVN's and am starting to integrate docker and docker swarm. My old site was also before I embraced frameworks (like Vue, React, Ember, and Bootstrap), so it was all vanilla.</p>
  <p>Below are the projects or tools I've built. I primarily code everything in Javascript, but have minor experience with C++, Obj-C, and BrightScript. Currently studying Kotlin and Swift. I also now try to mockup everything before I even start coding...even this site redesign was mocked up. When relevant, I will also showcase the mockups to the code.</p>
  <p>I'll add my projects below, my Linkedin is more current than my site, so feel free to look at that.</p>
 </main>
</template>
<script>
import updateAvatarTitle from '@/lib/updateAvatarTitle';
export default {
 mounted(){
  updateAvatarTitle('Projects',this);
 }
}
</script>
